import { ROUTES } from 'src/enums';

export default [
  {
    path: '/reply',
    meta: { auth: true, reply: true },
    component: () => import('layouts/SpaLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('layouts/ReplyLayout.vue'),
        children: [
          {
            path: '',
            name: ROUTES.REPLY.ADD_BRAND,
            component: () => import('pages/reply/AddBrandPage.vue'),
          },
          {
            path: ':brandGuid',
            component: () => import('layouts/ProxyLayout.vue'),
            children: [
              {
                path: '',
                name: ROUTES.REPLY.MENTIONS,
                component: () => import('pages/reply/MentionsPage.vue'),
              },
              {
                path: 'keywords',
                name: ROUTES.REPLY.KEYWORDS,
                component: () => import('pages/reply/KeywordsPage.vue'),
              },
              {
                path: 'replies',
                name: ROUTES.REPLY.REPLIES,
                component: () => import('pages/reply/RepliesPage.vue'),
              },
              {
                path: 'brand-voice',
                name: ROUTES.REPLY.BRAND_VOICE,
                component: () => import('pages/BrandVoicePage.vue'),
              },
            ],
          },
        ],
      },
    ],
  },
];
